<template lang="pug">
    div.contacts
        navbar
        section.section.section-1.is-relative
            div.is-vmiddle
                div.container.has-text-white.has-text-centered
                    h1.is-size-2.is-uppercase.has-text-weight-light.animated.fadeInUp.slow(v-html="$t('page_07.section_1.title')")

        section.section.section-2.is-relative
            div.container
                div.columns.is-vcentered
                    div.column.is-4.is-relative
                        div.on-middle
                            div.contacts-details
                                div.has-text-centered-mobile
                                    h1.is-size-11.is-uppercase.has-letter-spacing-200 {{ $t('page_07.block_1.title') }}
                                    h2.is-size-6.has-text-weight-bold.has-line-height {{ $t('page_07.block_1.subtitle') }}
                                    p(v-html="$t('page_07.block_1.adress')")
                                    p
                                        b E.
                                        |  {{ $t('page_07.block_1.email') }}
                                    p
                                        b Tlf.
                                        |  {{ $t('page_07.block_1.phone') }}
                                    p
                                        b Tlm.
                                        |  {{ $t('page_07.block_1.mobile') }}
                                    p {{ $t('page_07.block_1.closing_time') }}

                                div.has-text-centered-mobile
                                    h1.is-size-11.is-uppercase.has-letter-spacing-200 {{ $t('page_07.block_2.title') }}
                                    h2.is-size-6.has-text-weight-bold.has-line-height {{ $t('page_07.block_2.subtitle') }}
                                    p(v-html="$t('page_07.block_2.adress')")
                                    p
                                        b E.
                                        |  {{ $t('page_07.block_1.email') }}
                                    p
                                        b Tlm.
                                        |  {{ $t('page_07.block_1.mobile') }}

                    div.column
                        div#map-anchor.contacts-map
                        //- div#map-anchor.contacts-map.is-relative
                        //-     iframe(
                        //-         frameborder="0",
                        //-         scrolling="no",
                        //-         marginheight="0", marginwidth="0",
                        //-         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d793534.1827022246!2d-8.675102221427435!3d39.021177948388676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd175929b61827a5%3A0xd2ba9d6ca9a770ff!2sCasa+Relvas!5e0!3m2!1sen!2spt!4v1553077478372",
                        //-         style="position:absolute; top:0; left:0; width:100%; height:100%;"
                        //-     )
        the-footer
</template>

<script>
import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'

export default {
    name: 'contacts',
    components: { Navbar, TheFooter },
    mounted () {
        const map = document.querySelector('#map-anchor')
        map.style.width = document.documentElement.clientWidth - map.getBoundingClientRect().left + 'px'
    }
}
</script>

<style lang="stylus" scoped>

.section-1
    height calc(100vw / 3.49)
    background-image url("../assets/images/7_contactos/banner_Contactos.jpg")
    background-size cover

    @media screen and (max-width 768px)
        height 100vh
        background-image url("../assets/images/7_contactos/Contactos_banners-mobile.jpg")

.contacts
    &-details
        div + div
            margin-top 4.6875rem

        h1
            margin-bottom 2.5rem

    &-map
        background-image url("../assets/images/7_contactos/Mapa_desktop.jpg")

        @media screen and (max-width 768px)
            height 100vh
            background-image url("../assets/images/7_contactos/Mapa_mobile.jpg")
            background-position center

        // uncomment for iframe
        // height 100%
        // min-height 600px

.section-2
    padding 6.875rem 0
    background-color #ebeff3

.contacts-map
    height 100%
    min-height 600px

</style>
